export default __webpack_public_path__ + "static/media/FreshmanSkyscraper.11af160e.png";